export const ADD_CAMERA_TIMEOUT = 30_000; // 30.000 ms = 30 sec
export const ADD_CAMERA_STATUS_TEXTS: Array<string> = [
  'addCameraFlow.addCamera.form.activate',
  'addCameraFlow.addCamera.form.status.add',
  'addCameraFlow.addCamera.form.status.request',
  'addCameraFlow.addCamera.form.status.setup',
  'addCameraFlow.addCamera.form.status.check',
];
